module.exports = __webpack_public_path__ + "static/media/coins.572bddc6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/coins.mp3
// module id = 2014
// module chunks = 103